import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormControlName } from '@angular/forms';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';
import { DataService } from '../../services/data.service';
import { ControlKeys, ControlKeysFrt } from './control-keys';
import { RatefileOpenService } from '../../services/ratefile-open/ratefile-open.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';



@Component({
    selector: 'app-ratefile-open',
    templateUrl: './ratefile-open.component.html',
    styleUrls: ['./ratefile-open.component.css'],
    standalone: false
})
export class RatefileOpenComponent implements OnInit {
  controlTypeSelected: any;
  fileTypeSelected: any;
  controlIdSelected: number;
  rateFileRecord: ControlKeys;
  rateFileDetails: ControlKeysFrt[];
  rateKeyDetails: ControlKeys[];
  controlKeys: ControlKeys;
  lastControlRecord: any;
  rateKeySelected: number;
  updateSuccessful = false;
  updateFailure = false;
  buttonDisable = false;
  currentRateKey: number;
  validationError = false;
  openMinDate: Date;
  closeMinDate: Date;
  tspOpenMinDate: Date;
  tspCloseMinDate: Date;
  effOpenMinDate: Date;
  effCloseMinDate: Date;
  disableInput= false;
  frtRateFileRecord: ControlKeysFrt;
  controlKeysFrt: ControlKeysFrt;
  frtOptionsMore: any[] = [
    { name: 'Create Bid Segment', value: 'Main Rate Filing' },
    { name: 'TSP Participation', value: 'TSP Participation' },
    { name: 'Modify Effective Date', value: 'Rate Effective Dates' }
  ];
  frtOptionsLess: any[] = [
    { name: 'Create Bid Segment', value: 'Main Rate Filing' },    
    { name: 'Modify Effective Date', value: 'Rate Effective Dates' }
  ];
  frtOptions: any[];
  hhgOptions: any[] = [
    { name: 'Main Rate Filing', value: 'Main Rate Filing' },
    { name: 'Supplemental Rate Filing', value: 'Supplemental Rate Filing' },
    { name: 'Rate Effective Dates', value: 'Rate Effective Dates' }
  ];
  datePickerConfig: Partial<BsDatepickerConfig>;
  rateFileOpenForm: UntypedFormGroup;

  frtDropdownOption : boolean;
  bidCycleName: string;
  openDateError1: boolean;
  openDateError2: boolean;
  openDateError3: boolean;
  openDateError4: boolean;
  closeDateError1: boolean;  
  closeDateError2: boolean;
  closeDateError3: boolean;
  closeDateError4: boolean;
  openDateErrorMsg1: string;
  openDateErrorMsg2: string;
  openDateErrorMsg3: string;
  openDateErrorMsg4: string;
  closeDateErrorMsg1: string;
  closeDateErrorMsg2: string;
  closeDateErrorMsg3: string;
  closeDateErrorMsg4: string;
  releaseDateErrorMsg1: string;
  releaseDateErrorMsg2: string;
  releaseDateErrorMsg3: string;
  releaseDateErrorMsg4: string;
  releaseDateError1: boolean;
  releaseDateError2: boolean;
  releaseDateError3: boolean;
  releaseDateError4: boolean;
  tspOpenDateErrorMsg1: string;
  tspOpenDateErrorMsg2: string;  
  tspOpenDateErrorMsg3: string;
  tspOpenDateErrorMsg4: string;
  tspOpenDateError1: boolean;  
  tspOpenDateError2: boolean;
  tspOpenDateError3: boolean;  
  tspOpenDateError4: boolean;
  tspCloseDateErrorMsg1: string;
  tspCloseDateErrorMsg2: string;
  tspCloseDateErrorMsg3: string;
  tspCloseDateErrorMsg4: string;  
  tspCloseDateError1: boolean;  
  tspCloseDateError2: boolean;
  tspCloseDateError3: boolean;  
  tspCloseDateError4: boolean;
  newEffectiveDate: Date;
  effOpenDateError1: boolean;
  effOpenDateError2: boolean;
  effOpenDateErrorMsg1: string;
  effOpenDateErrorMsg2: string;
  effCloseDateError1: boolean;
  effCloseDateError2: boolean;
  effCloseDateErrorMsg1: string;
  effCloseDateErrorMsg2: string;
  saveButtonText: string;
  createFlag = false;
  saveErrorMsg = '';
  valSaveError = false;
  valueChanged: boolean;
  constructor(private ratefileOpenService: RatefileOpenService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private dataService: DataService,
    private router: Router
  ) {}


  ngOnInit() {
    this.createForm();    
    this.formReset();
    this.disableInput = false;
    this.valueChanged = false;
    this.tmssLoader.show();
      this.ratefileOpenService.getRateFileRecordForControlType('FRT Rate Filing')
        .subscribe(rateFileRecords => {    
          this.rateFileDetails = rateFileRecords;  
          this.rateFileDetails.forEach(raterec => {      
            if (raterec.releasePending == 'Pending'){
              this.saveButtonText = "Save";
              this.createFlag = false;
               this.disableInputFields();
               this.disableInput = true;
            }
            this.tmssLoader.hide();
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get populated: ' + error);
          });
          if (this.disableInput == false){
            this.saveButtonText = "Create";
            this.createFlag = true;
            this.enableInputFields();
            let date1: Date;
            this.newEffectiveDate = new Date();
            date1 = new Date(this.rateFileDetails[0].dateEffectiveClose);
            this.newEffectiveDate = new Date(date1.valueOf() + 1000*60*60*24);
            //this.newEffectiveDate = new Date(this.rateFileDetails[0].dateEffectiveClose);
            this.rateFileOpenForm.controls['effOpenDate'].setValue(this.newEffectiveDate);
            this.rateFileOpenForm.controls['effOpenDate'].disable();
          }
          this.tmssLoader.hide();        
        }, (error) => {
          this.tmssLoader.hide();
          this.alertService.error('Error loading Rate File Record: ' + error);
        });
  }
 

  formReset() {
    this.rateFileOpenForm.controls['openDate'].setValue('');
    this.rateFileOpenForm.controls['closeDate'].setValue('');
    this.rateFileOpenForm.controls['releaseDate'].setValue('');
    this.openMinDate = new Date();
    this.closeMinDate = new Date();
    this.openMinDate.setDate(this.openMinDate.getDate());
    this.closeMinDate.setDate(this.closeMinDate.getDate());
    this.tspOpenMinDate = new Date();
    this.tspCloseMinDate = new Date();
    this.tspOpenMinDate.setDate(this.tspOpenMinDate.getDate());
    this.tspCloseMinDate.setDate(this.tspCloseMinDate.getDate());
    this.effOpenMinDate = new Date();
    this.effCloseMinDate = new Date();
    this.effOpenMinDate.setDate(this.effOpenMinDate.getDate());
    this.effCloseMinDate.setDate(this.effCloseMinDate.getDate());
    this.rateFileOpenForm.controls['controlId'].setValue(0);
    this.rateFileOpenForm.controls['rateKey'].setValue(0);
    this.datePickerConfig = Object.assign({},
      {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: this.openMinDate,
        dateInputFormat: 'MM/DD/YYYY'
      });
  }

  createForm() {
    this.rateFileOpenForm = this.fb.group({
      bidCycle: new UntypedFormControl('', [Validators.required]),
      openDate: new UntypedFormControl('', [Validators.required]),
      closeDate: new UntypedFormControl('', [Validators.required]),
      releaseDate: new UntypedFormControl('', [Validators.required]),
      tspOpenDate: new UntypedFormControl('', [Validators.required]),
      tspCloseDate: new UntypedFormControl('', [Validators.required]),
      effOpenDate: new UntypedFormControl('', [Validators.required]),
      effCloseDate: new UntypedFormControl('', [Validators.required]),
      controlId: new UntypedFormControl(''),
      rateKey: new UntypedFormControl('')
    });
  }

  openDateChange(openDate : Date){    
    const today = new Date();
    today.setHours(0, 0, 0, 0);  
    this.clearErrorFlagsMessages();  
    let closeDate = null;
    let releaseDate = null;
    let tspOpenDate = null;
    let tspCloseDate = null;
  
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);      
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);     
    } 
    if (this.rateFileOpenForm.controls['tspOpenDate'].value !== null) {
      tspOpenDate = new Date(this.rateFileOpenForm.controls['tspOpenDate'].value);      
    }
    if (this.rateFileOpenForm.controls['tspCloseDate'].value !== null) {
      tspCloseDate = new Date(this.rateFileOpenForm.controls['tspCloseDate'].value);      
    }   
    if (openDate !== null && closeDate !== null && openDate > closeDate) {       
        this.openDateErrorMsg1 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Close Date';
        this.validationError = true;
        this.openDateError1 = true;
    }
    if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
        this.openDateErrorMsg2 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
        this.validationError = true;
        this.openDateError2 = true;
      } 
    if((tspOpenDate != null) && (tspOpenDate < openDate)){
      this.openDateErrorMsg3 = 'TSP Participation Open Date is before Rate Filing Open Date';
      this.validationError = true;
      this.openDateError3 = true;
    }
    if((tspCloseDate != null) && (tspCloseDate < openDate)){
      this.openDateErrorMsg4 = 'TSP Participation Close Date is before Rate Filing Open Date';
      this.validationError = true;
      this.openDateError4 = true;
    }

  }
  
  closeDateChange(closeDate : Date){    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.clearErrorFlagsMessages();
    let openDate = null;
    let releaseDate = null;    
    let tspOpenDate = null;
    let tspCloseDate = null;

    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);      
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);     
    }
    if (this.rateFileOpenForm.controls['tspOpenDate'].value !== null) {
      tspOpenDate = new Date(this.rateFileOpenForm.controls['tspOpenDate'].value);      
    }
    if (this.rateFileOpenForm.controls['tspCloseDate'].value !== null) {
      tspCloseDate = new Date(this.rateFileOpenForm.controls['tspCloseDate'].value);      
    } 
    if (closeDate !== null && releaseDate !== null && closeDate > releaseDate) {
        this.closeDateErrorMsg1 = 'Ratefiling Close Date can\'t be greater than Release Date';
        this.validationError = true;
        this.closeDateError1 = true;
      }
      if (closeDate !== null && openDate !== null && openDate > closeDate) {
        this.closeDateErrorMsg2 = 'Ratefiling Open Date can\'t be greater than Close Date';
        this.validationError = true;
        this.closeDateError2 = true;
      }
      if((tspOpenDate != null) && (tspOpenDate > closeDate)){
        this.closeDateErrorMsg3 = 'TSP Participation Open Date is after Rate Filing Close Date';
        this.validationError = true;
        this.closeDateError3 = true;
      }
      if((tspCloseDate != null) && (tspCloseDate > closeDate)){
        this.closeDateErrorMsg4 = 'TSP Participation Close Date is after Rate Filing Close Date';
        this.validationError = true;
        this.closeDateError4 = true;
      }
  }

  releaseDateChange(releaseDate: Date){
    let openDate = null;
    let closeDate = null;
    let effOpenDate = null;
    let effCloseDate = null;
    this.clearErrorFlagsMessages();
    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);      
    }
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);      
    }
    if (this.rateFileOpenForm.controls['effOpenDate'].value != null){
      effOpenDate = new Date(this.rateFileOpenForm.controls['effOpenDate'].value);
    }
    if (this.rateFileOpenForm.controls['effCloseDate'].value != null){
      effCloseDate = new Date(this.rateFileOpenForm.controls['effCloseDate'].value);
    }
    if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
      this.releaseDateErrorMsg1 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
      this.validationError = true;
      this.releaseDateError1 = true;   
    }
    if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
      this.releaseDateErrorMsg2 = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
      this.validationError = true;
      this.releaseDateError2 = true; 
    }
    if (effOpenDate !== null && releaseDate !== null &&   effOpenDate < releaseDate) {
      this.releaseDateErrorMsg3 = 'Rate Effective Date can\'t be less than the Ratefiling Release Date';
      this.validationError = true;
      this.releaseDateError3 = true;
    }
    if (effCloseDate !== null && releaseDate !== null &&   effCloseDate < releaseDate) {
      this.releaseDateErrorMsg4 = 'Rate Expiry Date can\'t be less than the Ratefiling Release Date';
      this.validationError = true;
      this.releaseDateError4 = true;
    }
  }
  onCycleNameChange(cycleName: string){
    this.buttonDisable = false;
    this.updateSuccessful = false;
    this.valueChanged = true;
    this.clearErrorFlagsMessages();
  }
  tspOpenDateChange(tspOpenDate : Date){   
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.clearErrorFlagsMessages();
    let openDate = null;
    let closeDate = null;
    let tspCloseDate = null;

    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);      
    }
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);      
    }
    if (this.rateFileOpenForm.controls['tspCloseDate'].value !== null) {
      tspCloseDate = new Date(this.rateFileOpenForm.controls['tspCloseDate'].value);      
    }
    if((openDate == null) || (closeDate == null)){
      this.tspOpenDateErrorMsg1 = 'open date and close date need to be entered';
      this.validationError = true;
      this.tspOpenDateError1 = true;
    }
    if((tspOpenDate != null) && ((tspOpenDate < openDate) || (tspOpenDate > closeDate))){
      this.tspOpenDateErrorMsg2 = 'TSP participation open date sholud be on or after open date and on or before close date';
      this.validationError = true;
      this.tspOpenDateError2 = true;
    }
    if((tspOpenDate != null) && ((tspCloseDate < tspOpenDate))){
      this.tspOpenDateErrorMsg3 = 'TSP participation Open date sholud be on or before TSP Participation Close Date';
      this.validationError = true;
      this.tspOpenDateError3 = true;
    }
    this.openDateError3 = false;
    this.openDateError4 = false;
  }
  tspCloseDateChange(tspCloseDate : Date){   
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.clearErrorFlagsMessages();
    let openDate = null;
    let closeDate = null;
    let tspOpenDate = null;

    if (this.rateFileOpenForm.controls['openDate'].value !== null) {
      openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);      
    }
    if (this.rateFileOpenForm.controls['closeDate'].value !== null) {
      closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);      
    }
    if (this.rateFileOpenForm.controls['tspOpenDate'].value !== null) {
      tspOpenDate = new Date(this.rateFileOpenForm.controls['tspOpenDate'].value);      
    }
    if((openDate == null) || (closeDate == null)){
      this.tspCloseDateErrorMsg1 = 'open date and close date need to be entered';
      this.validationError = true;
      this.tspCloseDateError1 = true;
    }
    if((tspCloseDate != null) && ((tspCloseDate < openDate) || (tspCloseDate > closeDate))){
      this.tspCloseDateErrorMsg2 = 'TSP participation Close date sholud be on or after open date and on or before close date';
      this.validationError = true;
      this.tspCloseDateError2 = true;
    }
    if((tspCloseDate != null) && ((tspCloseDate < tspOpenDate))){
      this.tspCloseDateErrorMsg3 = 'TSP participation Close date sholud be on or after TSP Participation Open Date';
      this.validationError = true;
      this.tspCloseDateError3 = true;
    }
    this.closeDateError3 = false;
    this.closeDateError4 = false;
  }

  effOpenDateChange(effOpenDate : Date){ 
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.effOpenDateErrorMsg1 = '';
    this.effOpenDateErrorMsg2 = ''; 
    this.effCloseDateErrorMsg1 = '';
    this.effCloseDateErrorMsg2 = '';  
    this.effOpenDateError1 = false;  
    this.effOpenDateError2 = false;
    this.effCloseDateError1 = false;  
    this.effCloseDateError2 = false;
    this.validationError = false;   
    this.buttonDisable = false;
    this.updateSuccessful = false;
    let effCloseDate = null;
    let releaseDate = null;

    if (this.rateFileOpenForm.controls['effCloseDate'].value != null){
      effCloseDate = new Date(this.rateFileOpenForm.controls['effCloseDate'].value);
    }
    if (this.rateFileOpenForm.controls['releaseDate'].value !== null) {
      releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);     
    }

    if(effOpenDate != null && effOpenDate > effCloseDate){
      this.effOpenDateErrorMsg1 = 'Rate Effective Date is greater than Rate Expiry Date';
      this.effOpenDateError1 = true;
      this.validationError = true;
    }
    if(effOpenDate != null && effOpenDate < releaseDate){
      this.effOpenDateErrorMsg1 = 'Rate Effective Date is before the Release Date';
      this.effOpenDateError1 = true;
      this.validationError = true;
    }

  }
  effCloseDateChange(effCloseDate : Date){   
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.effOpenDateErrorMsg1 = '';
    this.effOpenDateErrorMsg2 = ''; 
    this.effCloseDateErrorMsg1 = '';
    this.effCloseDateErrorMsg2 = '';  
    this.effOpenDateError1 = false;  
    this.effOpenDateError2 = false;
    this.effCloseDateError1 = false;  
    this.effCloseDateError2 = false;
    this.validationError = false;   
    this.valSaveError = false;
    this.buttonDisable = false;
    this.updateSuccessful = false;
    let effOpenDate = null;

    if (this.rateFileOpenForm.controls['effOpenDate'].value != null){
      effOpenDate = new Date(this.rateFileOpenForm.controls['effOpenDate'].value);
    }
    if(effCloseDate != null &&  effCloseDate < effOpenDate){
      this.effCloseDateErrorMsg1 = 'Effective Close Date is less than Effective Open Date';
      this.effCloseDateError1 = true;
      this.validationError = true;
    }
  }

  clearErrorFlagsMessages(){
    this.validationError = false;
    this.valSaveError = false;
    this.buttonDisable = false;
    this.updateSuccessful = false;    
    this.openDateErrorMsg1 = '';
    this.openDateErrorMsg2 = '';
    this.openDateErrorMsg3 = '';
    this.openDateErrorMsg4 = '';
    this.openDateError1 = false;
    this.openDateError2 = false;
    this.openDateError3 = false;
    this.openDateError4 = false;
    this.closeDateErrorMsg1 = '';
    this.closeDateErrorMsg2 = '';  
    this.closeDateErrorMsg3 = '';
    this.closeDateErrorMsg4 = '';
    this.closeDateError1 = false;  
    this.closeDateError2 = false;
    this.closeDateError3 = false;  
    this.closeDateError4 = false;
    this.releaseDateError1 = false;
    this.releaseDateError2 = false;
    this.releaseDateError3 = false;
    this.releaseDateError4 = false;
    this.releaseDateErrorMsg1 = '';
    this.releaseDateErrorMsg2 = '';
    this.releaseDateErrorMsg3 = '';
    this.releaseDateErrorMsg4 = '';
    this.tspOpenDateErrorMsg1 = '';
    this.tspOpenDateErrorMsg2 = ''; 
    this.tspOpenDateErrorMsg3 = '';
    this.tspOpenDateErrorMsg4 = ''; 
    this.tspOpenDateError1 = false;  
    this.tspOpenDateError2 = false;
    this.tspOpenDateError3 = false;  
    this.tspOpenDateError4 = false;
    this.tspCloseDateErrorMsg1 = '';
    this.tspCloseDateErrorMsg2 = '';  
    this.tspCloseDateErrorMsg3 = '';
    this.tspCloseDateErrorMsg4 = ''; 
    this.tspCloseDateError1 = false;  
    this.tspCloseDateError2 = false;
    this.tspCloseDateError3 = false;  
    this.tspCloseDateError4 = false;
  }
  selectedRecord(controlId, i) {  
    this.disableInput = false;
    this.updateSuccessful = false;
    this.updateFailure = false;
    this.nullInputFields();
    this.tmssLoader.show();
    this.controlIdSelected = controlId;
    this.ratefileOpenService.getRateFileRecorForIdFrt(this.controlIdSelected).subscribe(ratefileRecord => {
      this.frtRateFileRecord = ratefileRecord;
      this.rateFileOpenForm.controls['openDate'].setValue(this.frtRateFileRecord.effectiveDate);
      this.rateFileOpenForm.controls['closeDate'].setValue(this.frtRateFileRecord.expiryDate);
      this.rateFileOpenForm.controls['releaseDate'].setValue(this.frtRateFileRecord.releaseDate);
      this.rateFileOpenForm.controls['bidCycle'].setValue(this.frtRateFileRecord.cycleName);
      this.rateFileOpenForm.controls['controlId'].setValue(this.frtRateFileRecord.controlId);
      this.rateFileOpenForm.controls['rateKey'].setValue(this.frtRateFileRecord.rateKey);
      this.rateFileOpenForm.controls['tspOpenDate'].setValue(this.frtRateFileRecord.dateBidCycleOpen);
      this.rateFileOpenForm.controls['tspCloseDate'].setValue(this.frtRateFileRecord.dateBidCycleClose);
      this.rateFileOpenForm.controls['effOpenDate'].setValue(this.frtRateFileRecord.dateEffectiveOpen);
      this.rateFileOpenForm.controls['effCloseDate'].setValue(this.frtRateFileRecord.dateEffectiveClose);
      this.buttonDisable = true;
      if(this.frtRateFileRecord.releasePending != 'Pending'){
        this.disableInputFields();
      } else{
        this.enableInputFields();
        this.rateFileOpenForm.controls['bidCycle'].disable();
      }
      if (this.createFlag){
        this.rateFileOpenForm.controls['effOpenDate'].setValue(this.newEffectiveDate);
        this.rateFileOpenForm.controls['bidCycle'].setValue('');
        this.enableInputFields();
      }
      this.currentRateKey = this.rateFileDetails[0].rateKey;

      this.tmssLoader.hide();
    }, (error) => {
      this.alertService.error('Rate File Record did not get populated');
      this.tmssLoader.hide();
    });
  }
  SaveRateFileRec(){
    this.valSaveError = false;
    this.validateBeforeSave();
    if (!this.valSaveError){
      this.SaveRateFile();
    }
  }
  SaveRateFile() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    this.controlKeysFrt = new ControlKeysFrt();
    this.rateKeySelected = this.rateFileDetails[0].rateKey;
    
    this.controlKeysFrt.controlId = this.rateFileOpenForm.controls['controlId'].value;
    this.controlKeysFrt.cycleName = this.rateFileOpenForm.controls['bidCycle'].value;
    this.controlKeysFrt.effectiveDate = this.rateFileOpenForm.controls['openDate'].value;
    this.controlKeysFrt.expiryDate = this.rateFileOpenForm.controls['closeDate'].value;
    this.controlKeysFrt.releaseDate = this.rateFileOpenForm.controls['releaseDate'].value;
    this.controlKeysFrt.dateBidCycleOpen = this.rateFileOpenForm.controls['tspOpenDate'].value;
    this.controlKeysFrt.dateBidCycleClose = this.rateFileOpenForm.controls['tspCloseDate'].value;
    this.controlKeysFrt.dateEffectiveOpen = this.rateFileOpenForm.controls['effOpenDate'].value;
    this.controlKeysFrt.dateEffectiveClose = this.rateFileOpenForm.controls['effCloseDate'].value; 
    this.controlKeysFrt.releasePending = 'Pending';
    this.controlKeysFrt.updateProgram = 'Rate_File_Open';
    this.controlKeysFrt.updateDate = today;
    this.controlKeysFrt.updateId = 0;      
    this.tmssLoader.show();
    this.updateSuccessful = false;
    this.updateFailure = false; 
           
    this.ratefileOpenService.createControlKeysFrt(this.controlKeysFrt)
        .subscribe(data => {
          if (data.controlId !== 0) {              
            this.updateFailure = false;
            this.updateSuccessful = true;
            this.controlIdSelected = data.controlId;
            this.rateFileDetails = [];             
            this.ratefileOpenService.getRateFileRecordForControlType('FRT Rate Filing')
                .subscribe(rateFileRecords => {                
                  this.rateFileDetails = rateFileRecords as ControlKeysFrt[];
                  rateFileRecords.forEach(raterec => {
                    rateFileRecords.effectiveDate = raterec.effectiveDate;
                    rateFileRecords.expiryDate = raterec.expiryDate;
                    rateFileRecords.releaseDate = raterec.releaseDate;
                    rateFileRecords.controlId = raterec.controlId;
                    rateFileRecords.cycleName = raterec.cycleName;
                    if (raterec.releasePending == 'Pending'){
                      this.saveButtonText = "Save";
                      this.createFlag = false;
                       this.disableInputFields();
                       this.disableInput = true;
                    }
                    this.tmssLoader.hide();
                  }, (error) => {
                    this.tmssLoader.hide();
                    this.alertService.error('Rate File Record did not get populated');
                    this.updateFailure = true;
                    this.updateSuccessful = false;
                  });
                  this.ratefileOpenService.sendEmail(this.controlIdSelected)
                    .subscribe(result => {
                      console.log(result);
                    });
                });
            } else {
              this.tmssLoader.hide();
              this.alertService.error('Control Id is zero ');
              this.updateFailure = true;
              this.updateSuccessful = false;
            }
          }, (error) => {
            this.tmssLoader.hide();
            this.alertService.error('Rate File Record did not get updated');
            this.updateFailure = true;
            this.updateSuccessful = false;
          });
  }

  validateBeforeSave(){
    this.saveErrorMsg = '';
    let bidCycle = this.rateFileOpenForm.controls['bidCycle'].value;
    let openDate = new Date(this.rateFileOpenForm.controls['openDate'].value);
    let closeDate = new Date(this.rateFileOpenForm.controls['closeDate'].value);
    let releaseDate = new Date(this.rateFileOpenForm.controls['releaseDate'].value);
    let tspOpenDate = new Date(this.rateFileOpenForm.controls['tspOpenDate'].value);
    let tspCloseDate = new Date(this.rateFileOpenForm.controls['tspCloseDate'].value);
    let effOpenDate = new Date(this.rateFileOpenForm.controls['effOpenDate'].value);
    let effCloseDate = new Date(this.rateFileOpenForm.controls['effCloseDate'].value); 

    if (bidCycle == null || bidCycle == ''){
      this.saveErrorMsg = 'Bid Cycle is required';
      this.valSaveError = true;
      return;
    }
    if (openDate !== null && closeDate !== null && openDate > closeDate) {       
      this.saveErrorMsg = 'Ratefiling Open Date can\'t be greater than the Ratefiling Close Date';
      this.valSaveError = true;
      return;
  }
  if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
      this.saveErrorMsg = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
      this.valSaveError = true;
      return;
    } 
  if ((tspOpenDate != null) && (tspOpenDate < openDate)){
    this.saveErrorMsg = 'TSP Participation Open Date is before Rate Filing Open Date';
    this.valSaveError = true;
    return;
  }
  if ((tspCloseDate != null) && (tspCloseDate < openDate)){
    this.saveErrorMsg = 'TSP Participation Close Date is before Rate Filing Open Date';
    this.valSaveError = true;
    return;
  } 
  if (openDate !== null && closeDate !== null && openDate > closeDate) {       
      this.saveErrorMsg = 'Ratefiling Open Date can\'t be greater than the Ratefiling Close Date';
      this.valSaveError = true;
      return;
  }
  if (openDate !== null && releaseDate !== null && openDate > releaseDate) {
      this.saveErrorMsg = 'Ratefiling Open Date can\'t be greater than the Ratefiling Release Date';
      this.valSaveError = true;
      return;
    } 
  if ((tspOpenDate != null) && (tspOpenDate < openDate)){
    this.saveErrorMsg = 'TSP Participation Open Date is before Rate Filing Open Date';
    this.valSaveError = true;
    return;
  }
  if ((tspCloseDate != null) && (tspCloseDate < openDate)){
    this.saveErrorMsg = 'TSP Participation Close Date is before Rate Filing Open Date';
    this.valSaveError = true;
    return;
  }
  if (closeDate !== null && releaseDate !== null && closeDate > releaseDate) {
    this.saveErrorMsg = 'Ratefiling Close Date can\'t be greater than Release Date';
    this.valSaveError = true;
    return;
  }
  if (closeDate !== null && openDate !== null && openDate > closeDate) {
    this.saveErrorMsg = 'Ratefiling Open Date can\'t be greater than Close Date';
    this.valSaveError = true;
    return;
  }
  if((tspOpenDate != null) && (tspOpenDate > closeDate)){
    this.saveErrorMsg = 'TSP Participation Open Date is after Rate Filing Close Date';
    this.valSaveError = true;
    return;
  }
  if((tspCloseDate != null) && (tspCloseDate > closeDate)){
    this.saveErrorMsg = 'TSP Participation Close Date is after Rate Filing Close Date';
    this.valSaveError = true;
    return;
  }
  if((openDate == null) || (closeDate == null)){
    this.saveErrorMsg = 'open date and close date need to be entered';
    this.valSaveError = true;
    return;
  }
  if((tspOpenDate != null) && ((tspOpenDate < openDate) || (tspOpenDate > closeDate))){
    this.saveErrorMsg = 'TSP participation open date sholud be on or after open date and on or before close date';
    this.valSaveError = true;
    return;
  }
  if((tspOpenDate != null) && ((tspCloseDate < tspOpenDate))){
    this.saveErrorMsg = 'TSP participation Open date sholud be on or before TSP Participation Close Date';
    this.valSaveError = true;
    return;
    }
  if((tspCloseDate != null) && ((tspCloseDate < openDate) || (tspCloseDate > closeDate))){
      this.saveErrorMsg = 'TSP participation Close date sholud be on or after open date and on or before close date';
      this.valSaveError = true;
      return;
  }
  if((tspCloseDate != null) && ((tspCloseDate < tspOpenDate))){
      this.saveErrorMsg = 'TSP participation Close date sholud be on or after TSP Participation Open Date';
      this.valSaveError = true;
      return;
    }
    if(effOpenDate != null && effOpenDate > effCloseDate){
      this.saveErrorMsg = 'Rate Effective Date is greater than Rate Expiry Date';
      this.valSaveError = true;
      return;
    }
    if(effOpenDate != null && effOpenDate < releaseDate){
      this.saveErrorMsg = 'Rate Effective Date is before the Release Date';
      this.valSaveError = true;
      return;
    }
    if(effCloseDate != null &&  effCloseDate < effOpenDate){
      this.saveErrorMsg = 'Effective Close Date is less than Effective Open Date';
      this.valSaveError = true;
      return;
    }
  }
  disableInputFields(){
    this.rateFileOpenForm.controls['bidCycle'].disable();
    this.rateFileOpenForm.controls['openDate'].disable();
    this.rateFileOpenForm.controls['closeDate'].disable();
    this.rateFileOpenForm.controls['releaseDate'].disable();
    this.rateFileOpenForm.controls['tspOpenDate'].disable();
    this.rateFileOpenForm.controls['tspCloseDate'].disable();
    this.rateFileOpenForm.controls['effOpenDate'].disable();
    this.rateFileOpenForm.controls['effCloseDate'].disable();
  }

  enableInputFields(){
    this.rateFileOpenForm.controls['bidCycle'].enable();
    this.rateFileOpenForm.controls['openDate'].enable();
    this.rateFileOpenForm.controls['closeDate'].enable();
    this.rateFileOpenForm.controls['releaseDate'].enable();
    this.rateFileOpenForm.controls['tspOpenDate'].enable();
    this.rateFileOpenForm.controls['tspCloseDate'].enable();
    this.rateFileOpenForm.controls['effOpenDate'].enable();
    this.rateFileOpenForm.controls['effCloseDate'].enable();
  }
  clearPage() {
    this.tmssLoader.show();
    this.rateFileOpenForm.controls['bidCycle'].setValue('');
    this.rateFileOpenForm.controls['openDate'].setValue('');
    this.rateFileOpenForm.controls['closeDate'].setValue('');
    this.rateFileOpenForm.controls['releaseDate'].setValue('');   
    this.rateFileOpenForm.controls['tspOpenDate'].setValue('');
    this.rateFileOpenForm.controls['tspCloseDate'].setValue('');
    this.rateFileOpenForm.controls['effOpenDate'].setValue('');
    this.rateFileOpenForm.controls['effCloseDate'].setValue('');
    this.tmssLoader.hide();
  }
  nullInputFields(){
    this.rateFileOpenForm.controls['openDate'].setValue(null);
    this.rateFileOpenForm.controls['closeDate'].setValue(null);
    this.rateFileOpenForm.controls['releaseDate'].setValue(null);   
    this.rateFileOpenForm.controls['tspOpenDate'].setValue(null);
    this.rateFileOpenForm.controls['tspCloseDate'].setValue(null);
    this.rateFileOpenForm.controls['effOpenDate'].setValue(null);
    this.rateFileOpenForm.controls['effCloseDate'].setValue(null);
  }


  public markControlsAsTouched(rootControl: UntypedFormGroup | UntypedFormArray,
    visitChildren: boolean = true) {

    const stack: (UntypedFormGroup | UntypedFormArray)[] = [];

    // Stack the root FormGroup or FormArray
    if (rootControl &&
      (rootControl instanceof UntypedFormGroup || rootControl instanceof UntypedFormArray)) {
      stack.push(rootControl);
    }
    while (stack.length > 0) {
      const currentControl = stack.pop();
      (<any>Object).values(currentControl.controls).forEach((control) => {
        // If there are nested forms or formArrays, stack them to visit later
        if (visitChildren &&
          (control instanceof UntypedFormGroup || control instanceof UntypedFormArray)
        ) {          
          stack.push(control);
        } else {    
          control.markAsTouched();
          control.setErrors(null);
        }
      });
    }
  }
}
